import { render } from "./Gallerij.vue?vue&type=template&id=3173a16a"
import script from "./Gallerij.vue?vue&type=script&lang=js"
export * from "./Gallerij.vue?vue&type=script&lang=js"
script.render = render

export default script